import { defineMessages } from 'react-intl';

export const serviceInformationCardMessages = defineMessages({
  cardHeadline: {
    id: 'serviceInformationCard.cardHeadline',
    defaultMessage: 'Service Informationen',
  },
});

export const deliveryMessages = defineMessages({
  deliveryInfo: {
    id: 'delivery.deliveryInfo',
    defaultMessage: 'Levering',
  },
});

export const additionalCostsMessages = defineMessages({
  additionalCostsInfo: {
    id: 'additionalCosts.additionalCostsInfo',
    defaultMessage: 'Bezorg- & retourkosten',
  },
});
